<template>
  <section class="contact py-5">
    <div class="container">
      <div class="row justify-content-between g-4">
        <!-- Colonna Sinistra - Info -->
        <div class="col-lg-5">
          <div class="sticky-top" style="top: 2rem;">
            <span class="badge bg-primary-subtle text-primary mb-2">Contattaci</span>
            <h2 class="display-5 fw-bold mb-3">Parliamo del Tuo Progetto</h2>
            <p class="lead mb-4">
              Scopri come il nostro software può ottimizzare la gestione della tua attività.
              Richiedi una demo personalizzata.
            </p>

            <!-- Cards Features con hover effect migliorato -->
            <div class="d-grid gap-3 mb-4">
              <div class="feature-card bg-white p-3 rounded-3 shadow-sm">
                <div class="d-flex align-items-center">
                  <div class="feature-icon bg-primary-subtle text-primary rounded-2 me-3">
                    <i class="bi bi-laptop"></i>
                  </div>
                  <div>
                    <h5 class="mb-1">Richiedi una Demo</h5>
                    <p class="small text-muted mb-0">Demo personalizzata del software</p>
                  </div>
                </div>
              </div>

              <div class="feature-card bg-white p-3 rounded-3 shadow-sm">
                <div class="d-flex align-items-center">
                  <div class="feature-icon bg-primary-subtle text-primary rounded-2 me-3">
                    <i class="bi bi-headset"></i>
                  </div>
                  <div>
                    <h5 class="mb-1">Supporto Dedicato</h5>
                    <p class="small text-muted mb-0">Assistenza e formazione personalizzata</p>
                  </div>
                </div>
              </div>

              <div class="feature-card bg-white p-3 rounded-3 shadow-sm">
                <div class="d-flex align-items-center">
                  <div class="feature-icon bg-primary-subtle text-primary rounded-2 me-3">
                    <i class="bi bi-gear"></i>
                  </div>
                  <div>
                    <h5 class="mb-1">Personalizzazione</h5>
                    <p class="small text-muted mb-0">Soluzioni su misura per te</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Testimonial Card Migliorata -->
            <div class="testimonial-card bg-white p-4 rounded-3 shadow-sm">
              <div class="d-flex gap-3">
                <div class="testimonial-avatar rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center"
                     style="width: 48px; height: 48px;">
                  <i class="bi bi-person text-primary"></i>
                </div>
                <div>
                  <p class="mb-2 fst-italic">
                    "Il software ha rivoluzionato la gestione della nostra attività.
                    Ora tutto è più organizzato ed efficiente."
                  </p>
                  <h6 class="mb-1">Mario Rossi</h6>
                  <p class="small text-muted mb-0">Concessionaria Auto FVG</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Colonna Destra - Form -->
        <div class="col-lg-6">
          <div class="contact-form-card bg-white p-4 rounded-3 shadow-sm">
            <h4 class="mb-4">Richiedi Informazioni</h4>
            <form @submit.prevent="submitForm" class="needs-validation">
              <div class="row g-3">
                <!-- Form fields migliorati -->
                <div class="col-md-6">
                  <label class="form-label">Nome e Cognome</label>
                  <input
                    type="text"
                    class="form-control form-control-lg"
                    v-model="form.name"
                    required
                  >
                </div>

                <div class="col-md-6">
                  <label class="form-label">Email</label>
                  <input
                    type="email"
                    class="form-control form-control-lg"
                    v-model="form.email"
                    required
                  >
                </div>

                <div class="col-md-6">
                  <label class="form-label">Telefono</label>
                  <input
                    type="tel"
                    class="form-control form-control-lg"
                    v-model="form.phone"
                  >
                </div>

                <div class="col-md-6">
                  <label class="form-label">Interessato a</label>
                  <select
                    class="form-select form-select-lg"
                    v-model="form.interest"
                    required
                  >
                    <option value="">Seleziona...</option>
                    <option value="demo">Richiedi Demo</option>
                    <option value="auto">Gestione Auto</option>
                    <option value="immobili">Gestione Immobili</option>
                    <option value="completo">Soluzione Completa</option>
                  </select>
                </div>

                <div class="col-12">
                  <label class="form-label">Messaggio</label>
                  <textarea
                    class="form-control"
                    v-model="form.message"
                    rows="4"
                    required
                  ></textarea>
                </div>

                <div class="col-12">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.privacy"
                      required
                      id="privacy"
                    >
                    <label class="form-check-label" for="privacy">
                      Accetto la <a href="#" class="text-primary">Privacy Policy</a>
                    </label>
                  </div>
                </div>

                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg w-100"
                    :disabled="loading"
                  >
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    {{ loading ? 'Invio in corso...' : 'Invia Richiesta' }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      loading: false,
      form: {
        name: '',
        email: '',
        phone: '',
        interest: '',
        message: '',
        privacy: false
      }
    }
  },
  methods: {
    async submitForm() {
      this.loading = true
      try {
        // Qui andrà la logica di invio del form
        await new Promise(resolve => setTimeout(resolve, 1500))
        alert('Messaggio inviato con successo! Ti contatteremo presto.')
        this.resetForm()
      } catch (error) {
        alert('Errore durante l\'invio del messaggio. Riprova più tardi.')
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      this.form = {
        name: '',
        email: '',
        phone: '',
        interest: '',
        message: '',
        privacy: false
      }
    }
  }
}
</script>

<style scoped>
.contact {
  background: #f8f9fa;
}

.badge {
  background: #8ecae6 !important;
  color: #023047 !important;
}

.feature-icon {
  background: #8ecae6 !important;
  color: #023047 !important;
}

.feature-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0,0,0,0.05);
}

.feature-card:hover {
  transform: translateX(5px);
  border-color: #219ebc !important;
}

.testimonial-card {
  border-left: 4px solid #219ebc !important;
}

.contact-form-card {
  border: 1px solid rgba(0,0,0,0.05);
}

/* Input styles */
.form-control, .form-select {
  border: 1px solid rgba(0,0,0,0.1);
  padding: 0.75rem 1rem;
}

.form-control:focus, .form-select:focus {
  border-color: #219ebc !important;
  box-shadow: 0 0 0 0.25rem rgba(33, 158, 188, 0.1);
}

/* Animazioni */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.feature-card, .testimonial-card, .contact-form-card {
  animation: fadeIn 0.6s ease forwards;
}

/* Responsive */
@media (max-width: 991.98px) {
  .sticky-top {
    position: relative !important;
    top: 0 !important;
    margin-bottom: 2rem;
  }
}

.btn-primary {
  background: #219ebc !important;
  border-color: #219ebc !important;
}

.btn-primary:hover {
  background: #023047 !important;
  border-color: #023047 !important;
}
</style>
